import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ConstructionIcon from '@mui/icons-material/Construction';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import PlumbingIcon from '@mui/icons-material/Plumbing';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import FormatPaintIcon from '@mui/icons-material/FormatPaint';
import CarpenterIcon from '@mui/icons-material/Carpenter';
import BathroomIcon from '@mui/icons-material/Bathroom';
import KitchenIcon from '@mui/icons-material/Kitchen';
import RoofingIcon from '@mui/icons-material/Roofing';
import FlooringIcon from '@mui/icons-material/Layers';
import DoorFrontIcon from '@mui/icons-material/DoorFront';
import WallIcon from '@mui/icons-material/ViewQuilt';

export const serviceCategories = [
  {
    id: 'neubau',
    title: 'Neubau',
    subtitle: 'Innenausbau für Neubauten',
    description: 'Kompletter Innenausbau für Neubauprojekte — von der Rohbauphase bis zum schlüsselfertigen Ergebnis. Wir realisieren Ihren Traum vom perfekten Zuhause oder Gewerberaum.',
    path: '/neubau',
    icon: HomeWorkIcon,
    heroDescription: 'Wir verwandeln Rohbauten in hochwertige Wohn- und Gewerberäume. Von der ersten Trockenbau­wand bis zum letzten Anstrich — alles aus einer Hand.',
    features: [
      {
        icon: ArchitectureIcon,
        title: 'Trockenbau & Ständerwerk',
        description: 'Professioneller Trockenbau mit modernsten Materialien. Wandsysteme, Deckenverkleidungen und Dachgeschossausbau.'
      },
      {
        icon: ElectricalServicesIcon,
        title: 'Elektroinstallation',
        description: 'Komplette Elektroinstallation inkl. Smart-Home-Vorbereitung, Beleuchtungskonzepte und Netzwerkverkabelung.'
      },
      {
        icon: PlumbingIcon,
        title: 'Sanitärinstallation',
        description: 'Sanitäre Anlagen, Wasseranschlüsse und moderne Badsysteme — fachgerecht und normgerecht installiert.'
      },
      {
        icon: FlooringIcon,
        title: 'Bodenbeläge',
        description: 'Parkett, Fliesen, Designböden oder Estrich — wir verlegen jeden Bodenbelag fachgerecht und präzise.'
      },
      {
        icon: FormatPaintIcon,
        title: 'Malerarbeiten',
        description: 'Innenanstriche, Tapezierarbeiten, Spachteltechnik und dekorative Wandgestaltung.'
      },
      {
        icon: DoorFrontIcon,
        title: 'Türen & Fenster',
        description: 'Einbau von Innentüren, Zargen und Fensterbänken — passgenau und hochwertig.'
      },
    ],
    process: [
      { step: 1, title: 'Beratung & Planung', description: 'Persönliches Erstgespräch, Aufmaß und detaillierte Projektplanung.' },
      { step: 2, title: 'Angebot', description: 'Transparentes, detailliertes Angebot mit allen Leistungen und Materialien.' },
      { step: 3, title: 'Ausführung', description: 'Professionelle Umsetzung mit regelmäßiger Abstimmung und Qualitätskontrolle.' },
      { step: 4, title: 'Abnahme', description: 'Gemeinsame Endabnahme und Übergabe — erst wenn Sie zufrieden sind.' },
    ],
  },
  {
    id: 'umbau',
    title: 'Umbau',
    subtitle: 'Umbau & Modernisierung',
    description: 'Umbau und Modernisierung bestehender Räumlichkeiten — wir schaffen neue Raumkonzepte, optimieren Grundrisse und bringen Ihre Räume auf den neuesten Stand.',
    path: '/umbau',
    icon: ConstructionIcon,
    heroDescription: 'Ob Grundrissänderung, Raumteilung oder kompletter Umbau — wir verwandeln bestehende Räume in moderne, funktionale Wohn- und Arbeitswelten.',
    features: [
      {
        icon: WallIcon,
        title: 'Grundrissänderungen',
        description: 'Wände versetzen, Durchbrüche schaffen und neue Raumkonzepte realisieren.'
      },
      {
        icon: BathroomIcon,
        title: 'Badezimmer-Umbau',
        description: 'Komplette Badsanierung von der Entkernung bis zur Fertigstellung — barrierefrei und modern.'
      },
      {
        icon: KitchenIcon,
        title: 'Küchen-Umbau',
        description: 'Neue Küchenräume schaffen, Anschlüsse verlegen und professionell einbauen.'
      },
      {
        icon: RoofingIcon,
        title: 'Dachgeschossausbau',
        description: 'Wohnraum im Dachgeschoss schaffen — mit Dämmung, Trockenbau und kompletter Ausstattung.'
      },
      {
        icon: FlooringIcon,
        title: 'Bodenarbeiten',
        description: 'Alte Beläge entfernen, Untergründe vorbereiten und neue Bodenbeläge fachgerecht verlegen.'
      },
      {
        icon: CarpenterIcon,
        title: 'Schreinerarbeiten',
        description: 'Maßgefertigte Einbaumöbel, Verkleidungen und individuelle Holzarbeiten.'
      },
    ],
    process: [
      { step: 1, title: 'Bestandsaufnahme', description: 'Besichtigung und Analyse des Ist-Zustands vor Ort.' },
      { step: 2, title: 'Konzept & Planung', description: 'Erarbeitung eines Umbaukonzepts nach Ihren Wünschen.' },
      { step: 3, title: 'Genehmigungen', description: 'Unterstützung bei behördlichen Genehmigungen und Anträgen.' },
      { step: 4, title: 'Umsetzung', description: 'Professionelle Durchführung mit minimalem Aufwand für Sie.' },
    ],
  },
  {
    id: 'sanierung',
    title: 'Sanierung',
    subtitle: 'Sanierung & Renovierung',
    description: 'Fachgerechte Sanierung und Renovierung — wir bringen Altbauten und sanierungsbedürftige Objekte wieder in Topzustand und steigern nachhaltig den Wert Ihrer Immobilie.',
    path: '/sanierung',
    icon: AutoFixHighIcon,
    heroDescription: 'Altbausanierung, Wasserschadensanierung und energetische Modernisierung — wir hauchen Ihrem Objekt neues Leben ein.',
    features: [
      {
        icon: HomeWorkIcon,
        title: 'Altbausanierung',
        description: 'Behutsame Sanierung von Altbauten unter Berücksichtigung der Bausubstanz und des Denkmalschutzes.'
      },
      {
        icon: PlumbingIcon,
        title: 'Wasserschadensanierung',
        description: 'Schnelle und fachgerechte Beseitigung von Wasserschäden — Trocknung, Sanierung und Wiederherstellung.'
      },
      {
        icon: FormatPaintIcon,
        title: 'Fassadensanierung',
        description: 'Fassadenrenovierung, Wärmedämmung und Neuanstrich für eine moderne Optik.'
      },
      {
        icon: FlooringIcon,
        title: 'Bodensanierung',
        description: 'Aufarbeitung bestehender Böden oder kompletter Austausch mit neuen, hochwertigen Belägen.'
      },
      {
        icon: ElectricalServicesIcon,
        title: 'Elektro-Sanierung',
        description: 'Modernisierung veralteter Elektroinstallationen auf den aktuellen Stand der Technik.'
      },
      {
        icon: RoofingIcon,
        title: 'Energetische Sanierung',
        description: 'Dämmung, Fenstertausch und Heizungsoptimierung für mehr Energieeffizienz.'
      },
    ],
    process: [
      { step: 1, title: 'Schadensanalyse', description: 'Gründliche Begutachtung des Sanierungsbedarfs.' },
      { step: 2, title: 'Sanierungskonzept', description: 'Erstellung eines umfassenden Sanierungsplans mit Kostenschätzung.' },
      { step: 3, title: 'Sanierung', description: 'Schrittweise Sanierung mit laufender Dokumentation.' },
      { step: 4, title: 'Qualitätssicherung', description: 'Abschlusskontrolle und Gewährleistung der durchgeführten Arbeiten.' },
    ],
  },
];

export const serviceOverview = [
  {
    icon: HomeWorkIcon,
    title: 'Neubau',
    description: 'Kompletter Innenausbau für Neubauprojekte — schlüsselfertig.',
    path: '/neubau',
  },
  {
    icon: ConstructionIcon,
    title: 'Umbau',
    description: 'Umbau & Modernisierung bestehender Räumlichkeiten.',
    path: '/umbau',
  },
  {
    icon: AutoFixHighIcon,
    title: 'Sanierung',
    description: 'Fachgerechte Sanierung & Werterhaltung Ihrer Immobilie.',
    path: '/sanierung',
  },
];
